import {evite} from 'evite';
import urls from 'urls';
import {action, observable} from 'mobx';
import {GuestContactModel} from './guest_contact_model';
import {BaseContactStore} from '~/common/contacts/base_store';

export class ContactStore extends BaseContactStore {
  constructor(event, listType = 'contacts') {
    super();
    this.event = event;
    this.listType = listType;
    this.guestStore = null;
    this.setPagination(this.fetchContacts);
    this.setFilters();
  }

  @observable accessor allTheseContactsAreInDraftGuests = false;

  @observable accessor letters = [];

  // the guest store with which we'll coordinate
  setGuestStore(guestStore) {
    this.guestStore = guestStore;
  }

  /** *******************
   *Filter By Group
   ******************** */

  @action
  markAllVisibleAsUnSelected() {
    this.contacts.results.forEach((contact) => contact.removeFromGuestList());
    this.allTheseContactsAreInDraftGuests = false;
  }

  @action
  markAllVisibleAsSelected() {
    this.contacts.results.forEach((contact) => contact.addToGuestList());
    this.allTheseContactsAreInDraftGuests = true;
  }

  haveAllContactsBeenAdded = () =>
    // "have all contacts (from the current contacts group) been added to the guest list"
    this.allTheseContactsAreInDraftGuests;

  /** *******************
   *fetching
   ******************** */

  fetchContacts = async ({start, limit, sortBy, sortDirection, ...filters}) => {
    if (!this.event.id) {
      return [];
    }

    const url = urls.get('ajax_event_contacts', {
      event_id: this.event.id,
      query: this._getSearchQuery(),
      page: this.contacts.currentPage + 1,
      searchBy: this.searchBy,
      searchType: this.searchType,
      sortBy,
      reverse: sortDirection !== 'ASC',
      limit,
      listType: this.listType,
      groupId: filters.group || '',
    });
    try {
      this.loading = true;
      const response = await evite.fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
        },
      });

      if (response.ok) {
        const jsonResponse = await response.json();
        const contacts = jsonResponse.contacts || jsonResponse.guests;
        this.groups = jsonResponse.contact_groups;
        this.allTheseContactsAreInDraftGuests = jsonResponse.all_are_guests;
        this.contacts.setTotals(contacts.count);
        this.letters = jsonResponse.letters;
        return contacts.page.map((contact) => new GuestContactModel(contact, true));
      }
    } catch (e) {
      evite.error('Error fetching contacts');
      evite.error(e);
    } finally {
      this.loading = false;
    }

    return [];
  };

  /** *******************
   * remove all imported contacts
   ******************** */
  @action
  deleteAll = async () => {
    if (this.listType !== 'import') return;

    const url = urls.get('ajax_event_contacts_delete', {
      event_id: this.event.id,
      listType: this.listType,
    });
    try {
      const response = await evite.fetch(url, {
        method: 'delete',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
        },
      });
      if (response.ok) {
        const jsonResponse = await response.json();
        const {guests} = jsonResponse;
        return guests;
      }

      this.setFilters();
    } catch (e) {
      evite.error('Error in posting guest');
      evite.error(e);
    }
  };

  handleAddOrRemoveAll = async () => {
    const contactGroupId = this.getCurrentGroupId();
    const searchParams = this.getCurrentSearchParams();
    searchParams.type = this.listType;
    let needsRefresh = false;

    if (this.haveAllContactsBeenAdded()) {
      this.markAllVisibleAsUnSelected();
      const idsOfGuestsRemoved = await this.guestStore.deleteGuestsFromContactGroup(
        contactGroupId,
        searchParams
      );
      needsRefresh = idsOfGuestsRemoved.length > 0;
    } else {
      this.markAllVisibleAsSelected();
      const guestsRemoved = await this.guestStore.addGuestsFromAllContactsInGroup(
        contactGroupId,
        searchParams
      );
      needsRefresh = guestsRemoved.length > 0;
    }

    if (needsRefresh) {
      this.guestStore.refresh();
      this.guestStore.refreshContacts();
    }
  };
}
